<h4 class="font-weight-bold py-3 mb-4">Companies</h4>

<div class="card mb-4">
  <h6 class="card-header">
    Company Access
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Name</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let user of getAllUsers() | filter:shouldView()">
          <td>{{user.fullname}}</td>
          <td>
            <span *ngIf="accessRequested(user)">This company has requested access to your certificates</span>
            <span *ngIf="accessGranted(user)">This company has access to your certificates</span>
          </td>
          <td>
            <button class="btn btn-sm btn-danger" *ngIf="accessGranted(user)" (click)="revokeAccess(user)">Revoke access</button>
            <button class="btn btn-sm btn-success" *ngIf="accessRequested(user)" (click)="grantAccess(user)">Grant access</button>
          </td>
        </tr>
        <tr *ngIf="(getAllUsers() | filter:shouldView()).length === 0">
          <td colspan="3" style="text-align: center">
            There are currently no companies with access to your certificates
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
